import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=417cd63e&scoped=true&"
import script from "./BaseLabel.vue?vue&type=script&lang=js&"
export * from "./BaseLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417cd63e",
  null
  
)

export default component.exports